module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAABIklEQVR4AWOgC7inKYCCtATvKnHeVWQHMtCksGu4q8T+NNzldVXWXVUeAhruKnPeVWB75Kr/98O7b0f33RZluCPLdFeNB6eGpxGuD8wVXtfm/fv29cu2da/rC971NT60Uburwo1Fw10F1u+nj/559eLzppWfVi98P7P376ePf799/Xn98n09sXvqfBgaFNlepIf+ff/u191bQKueJwd+Xrfk3cSWRw5a93VE7mnwYzpJEOiBx16mQHWfVs7/sGDqv+/fXhYn3ZFmwOmHOwpsr4qS/rx9/ffzp4/LZv95/fLL9vVAf+PQoMEPRB9mT/h2dP/LgoS7ilyft6x+21l9R44FXzwA4+uuPCvQbffUeO7ri9/TESYccQikzge0E0XDoAQA6XDXW4lMgd8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/HK.png
// module id = 1159
// module chunks = 0